module.exports = __webpack_public_path__ + "img/56.610e87ce.jpg";